<template>
	<div id="app">
		<div class="_sp">
			<header class="header">
				<a class="logo" href="/"><img alt="" src="./assets/logo.svg"></a>

				<nav class="gnav">
					<label class="gnav-burger" :class="{ 'is-active': isBurgerOpen }" @click="isBurgerOpen = !isBurgerOpen">
						<span></span>
						<span></span>
						<span></span>
					</label>

					<div class="gnav-wrapper" :class="{ 'is-active': isBurgerOpen }">
						<a href="/"><img class="gnav-logo" alt="" src="./assets/logo_white.svg"></a>

						<ul class="gnav-menu">
							<li v-for="(row, index) in menus" :key="'gnav' + index">
								<a :href="'/' + row.routeName">{{ row.title }}</a>
							</li>
						</ul>
					</div>

					<div class="gnav-overlay" :class="{ 'is-active': isBurgerOpen }" @click="isBurgerOpen = !isBurgerOpen"></div>
				</nav>
			</header>
		</div>

		<div class="_pc">
			<header class="header">
				<div class="header-wrapper">
					<a class="logo" href="/"><img alt="" src="./assets/logo.svg"></a>
				</div>
			</header>
		</div>

		<nav class="gnav _pc">
			<ul class="gnav-menu">
				<li v-for="(row, index) in menus" :key="'gnav' + index">
					<a :href="'/' + row.routeName">{{ row.title }}</a>
				</li>
			</ul>
		</nav>

		<div class="container">
			<router-view/>
		</div>

		<footer class="footer">
			<ul class="footer-menu">
				<li v-for="(row, index) in footerMenus" :key="'footer' + index">
					<a :href="row.routeName">{{ row.title }}</a>
				</li>
			</ul>

			<div class="footer-address">
				<div>{{ $consts.ADDRESS }}</div>
				<div>E-mail:<a :href="'mailto:' + $consts.EMAIL">{{ $consts.EMAIL }}</a></div>
				<div class="_sp">tel:<a :href="'tel:' + $consts.TEL">{{ $consts.TEL }}</a></div>
				<div class="_pc">tel:{{ $consts.TEL }}</div>
			</div>

			<div class="footer-copy">&copy; Packers Co, Ltd. All Rights Reserved.</div>
		</footer>
	</div>
</template>

<style lang="scss">
@import "@/scss/_reset.scss";
@import "@/scss/style.scss";

html{
	font-size: 62.5%;
	height: 100%;
	min-height: 100%;
}

body{
	color: $fontColor;
	font-family:"游ゴシック Medium",YuGothic,YuGothicM,"Hiragino Kaku Gothic ProN","Hiragino Kaku Gothic Pro",メイリオ,Meiryo,sans-serif;
	width: 100vw;
	min-width: 320px;
	font-size: 1.3rem;
	line-height: 1.8;
	text-align: center;
}

.header {
	@include flex($justify: center);
	width: 100%;
	height: $headerH;
	position: fixed;
	background: #fff;
	top: 0;
	left: 0;

	.logo {
		line-height: 0;

		img {
			width: 120px;
		}
	}
}

a {
	text-decoration: none;
}

li {
	list-style: none;
}

h1 {
	font-size: 1.8rem;
	margin: 20px 0 10px 0;
}

h1.page-title-big,
h1.page-title {
	margin-top: 40px;
}

h1.page-title-big {
	font-size: 3.0rem;
}

h2.page-subtitle {
	font-size: 3.0rem;
	margin-top: -10px;
	margin-bottom: 5px;
}

.required::after {
	content: '必須';
	font-size: 10px;
	font-weight: normal;
	padding: 0 6px;
	margin-left: 10px;
	letter-spacing: 1px;
	border-radius: 2px;
	background-color: red;
	color: #fff;
	position: absolute;
	top: 4px;
}

.help-danger {
	color: red;
	margin-top: 5px;
}

textarea.is-danger,
select.is-danger,
div.is-danger div input,
input.is-danger {
	background: #ffc9ca !important;
	border-color: #febebf !important;
}

input[type=radio],input[type=checkbox] {
	position: relative;
	top: -2px;
	margin-right: 2px;
}

input[type=email],
input[type=tel],
input[type=text] {
	@include input;
}

textarea {
	@include textarea;
}

select {
	@include select;
}

.video{
  position:relative;
  width:100%;
  padding-top:56.25%;
}
.video iframe{
  position:absolute;
  top:0;
  right:0;
  width:100%;
  height:100%;
}

.explain {
	margin-bottom: 35px;
	h3 {
		font-size: 2.2rem;
		margin: 20px 0 12px 0;
	}

	&-text {
		font-size: 1.4rem;
		line-height: $wideLH;
	}
}

.attention {
	color: $baseColor;
	font-size: 2.0rem;
	font-weight: bold;
}

a.reserve {
	@include btn;
	margin-top: 30px;
}

.eyecatch {
	width: 100%;
}

.container {
	margin-top: $headerH;

	& > div {
		padding-bottom: 80px;
	}
}

.gnav {
	&-burger {
		display: block;
		width: 30px;
		height: 22px;
		vertical-align: middle;
		z-index: 999;
		position: absolute;
		right: 20px;
		top: 14px;

		span {
			height: 2px;
			width: 25px;
			border-radius: 3px;
			background: $fontColor;
			display: block;
			transform: rotate(0deg);
			position: absolute;
			top: 10px;

			&:nth-child(1) {
				transform: translateY(-10px);
			}

			&:nth-child(3) {
				transform: translateY(10px);
			}
		}

		&.is-active {
			span {
				background: #fff;

				&:nth-child(1) {
					transform: rotate(-45deg) translateY(0px);
				}
				&:nth-child(2) {
					background: transparent;
				}
				&:nth-child(3) {
					transform: rotate(45deg) translateY(0px);
				}
			}
		}
	}

	&-menu {
		a {
			text-decoration: none;
		}
	}

	&-overlay {
		background: #000;
		opacity: 0;
		pointer-events: none;
		width: 100%;
		height: 100%;
		position: fixed;
		top: 0;
		right: 0;
		z-index: 997;

		&.is-active {
			opacity: 0.3;
			pointer-events: auto;
		}
	}

	&-burger span,
	&-wrapper,
	&-wrapper.is-active,
	&-overlay {
		transition: all 0.2s;
	}

}

.footer {
	background: $baseColor;
	padding: 30px;

	&, a {
		color: #fff;
	}

	&-menu {
		@include flex($wrap:wrap, $justify: center);
		margin-bottom: 10px;

		li {
			margin-bottom: 10px;
			&:nth-child(4),
			&:nth-child(1),
			&:nth-child(2) {
				border-right: 1px #fff solid;
			}
		}
	}

	&-copy {
		margin-top: 15px;
	}
}

.vue-lb-info {
	@include flex($justify: center);
	bottom: 24px !important;
}

.loader {
  font-size: 5px;
  margin: 50px auto;
  text-indent: -9999em;
  width: 11em;
  height: 11em;
  border-radius: 50%;
  background: $baseColor;
  background: -moz-linear-gradient(left, $baseColor 10%, rgba(4,50,255, 0) 42%);
  background: -webkit-linear-gradient(left, $baseColor 10%, rgba(4,50,255, 0) 42%);
  background: -o-linear-gradient(left, $baseColor 10%, rgba(4,50,255, 0) 42%);
  background: -ms-linear-gradient(left, $baseColor 10%, rgba(4,50,255, 0) 42%);
  background: linear-gradient(to right, $baseColor 10%, rgba(4,50,255, 0) 42%);
  position: relative;
  -webkit-animation: load3 1.4s infinite linear;
  animation: load3 1.4s infinite linear;
  -webkit-transform: translateZ(0);
  -ms-transform: translateZ(0);
  transform: translateZ(0);
}
.loader:before {
  width: 50%;
  height: 50%;
  background: $baseColor;
  border-radius: 100% 0 0 0;
  position: absolute;
  top: 0;
  left: 0;
  content: '';
}
.loader:after {
  background: #feffff;
  width: 75%;
  height: 75%;
  border-radius: 50%;
  content: '';
  margin: auto;
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
}
@-webkit-keyframes load3 {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
@keyframes load3 {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}


@media #{map-get($mq, 'sp')} {
	$menuW: 250px;

	.header {
		z-index: 996;
	}

	.gnav {
		&-wrapper {
			padding-top: calc(#{$headerH} + 5px);
			position: absolute;
			top: 0;
			right: -$menuW;
			background: $baseColor;
			width: $menuW;
			height: 100vh;
			z-index: 998;

			&.is-active {
				right: 0;
			}
		}

		&-logo {
			width: 120px;
		}

		&-menu {
			margin-top: 20px;
			padding-bottom: 50px;
			text-align: left;

			li {
				border-bottom: 1px #fff solid;

				&:nth-child(1) {
					border-top: 1px #fff solid;
				}
			}

			a {
				display: block;
				color: #fff;
				padding: 18px;
			}
		}
	}

	.footer {
		&-menu {
			li {
				padding: 0 10px;
			}
		}
	}
}

@media #{map-get($mq, 'pc')} {
	h1 {
		font-size: 3.0rem;
	}

	h1.page-title-big,
	h1.page-title {
		margin-top: 110px;
	}

	h1.page-title-big {
		font-size: 4.6rem;
	}

	h2.page-subtitle {
		font-size: 4.6rem;
		line-height: 1.6;
		margin-bottom: 6px;
	}

	.header {
		z-index: 999;

		&-wrapper {
			@include flex($align: center);
			width: $pcContentsWidth;
			margin: 0 auto;
			line-height: 0;
		}
	}

	.gnav {
		width: 100%;
		position: fixed;
		top: $headerH;
		background: $baseColor;
		z-index: 999;

		&-menu {
			font-size: 1.6rem;
			@include flex($justify: center);
			height: $gnavH;

			li {
				width: 136px;
			}

			a {
				color: #fff;
			}
		}
	}

	.container {
		margin-top: $headerH + $gnavH;
	}

	.footer {
		&-menu {
			@include flex($justify: center);
			margin: 0 auto;
			margin-bottom: 20px;

			li {
				padding: 0 25px;
				&:not(:last-child) {
					border-right: 1px #fff solid;
				}
			}
		}
	}

	.explain {
		h3 {
			font-size: 3.0rem;
		}

		&-text {
			font-size: $pcFontSizeDescriptionTitle;
		}
	}
};
</style>

<script>

export default {
	name: 'App',
	components: {
	},
	data () {
		return {
			titleSuffix: '中部、東海、愛知県、名古屋エリアでキャンピングカーをレンタルするなら | キャンピングカーシェア【ゴーキャン！】',
			isBurgerOpen: false,
			menus: [],
			footerMenus: [],
		}
	},
	created() {
		this.menus = [
			{
				title: '名古屋店',
				routeName: 'cars',
			},
			//{
			//	title: '大阪店',
			//	routeName: 'osaka',
			//},
			{
				title: '川崎店',
				routeName: 'kawasaki',
			},
			//{
			//	title: '北陸店',
			//	routeName: 'hokuriku',
			//},
			//{
			//	title: 'シェア料金',
			//	routeName: 'price',
			//},
			{
				title: 'ご利用ガイド',
				routeName: 'guide',
			},
			{
				title: 'オプション',
				routeName: 'option',
			},
			//{
			//	title: 'コーティング',
			//	routeName: 'coating',
			//},
			{
				title: 'ご予約／お問合せ',
				routeName: 'contact',
			},
			//{
			//	title: 'よくある質問',
			//	routeName: 'faq',
			//},
			{
				title: 'アクセス',
				routeName: 'access',
			},
		];

		this.footerMenus = [
			{
				title: 'TOP',
				routeName: '/',
			},
			{
				title: '運営会社',
				routeName: '/company',
			},
			{
				title: '特定商取引法に基づく表記',
				routeName: '/company#tokusyo',
			},
			{
				title: 'よくある質問',
				routeName: '/faq',
			},
			//{
			//	title: 'オーナー様募集',
			//	routeName: '/owner-entry',
			//},
		];
		
	},
	mounted() {
		document.getElementsByTagName('title')[0].innerText = this.titleSuffix;
	},
	watch: {
		'$route' (to, from) {
			//this.$utils.log('App.vue watch');
			//this.$utils.log('to');
			//this.$utils.log(to.name);
			//this.$utils.log('from');
			//this.$utils.log(from.name);

			let title = to.meta.title ? to.meta.title + ' | ' : '';
			document.getElementsByTagName('title')[0].innerText = title + this.titleSuffix;
		}
	},
	computed: {
	},
	methods: {
	}
}
</script>
